import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import { Box, Flex, Text } from "@chakra-ui/react";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(...registerables);

function BarChart({ labels }: any) {
  const label = labels && labels.map((item: any) => item.bandeira);
  const total = labels && labels.map((item: any) => item.total);
  const vendas =
    labels && labels.map((item: any) => `vendas por ${item.bandeira}`);

  return (
    <Bar
      width={"80%"}
      height={"45%"}
      plugins={[ChartDataLabels]}
      options={{
        plugins: {
          legend: {
            display: false, //retira a legenda do gráfico
          },
          datalabels: {
            display: true,
            color: "black",
            align: "center",
          },
        },
      }}
      data={{
        labels: label,
        datasets: [
          {
            label: "",
            type: "bar",
            data: total,
            backgroundColor: [
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 99, 132, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(255, 206, 86, 0.2)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
            ],
            borderWidth: 1,
          },
        ],
      }}
    />
  );
}
export default BarChart;
